module.exports = new __parcel__URL__("train_5_active.66e4d70e.png").toString();